import {Observable, Subscription} from 'rxjs';

import IFrameStore from '../Interfaces/IFrameStore';

const subscribeToExitFullscreen = (
    exitFullscreen$: Observable<void>,
    frameStore: IFrameStore
): Subscription =>
    exitFullscreen$
        .subscribe(() => frameStore.actions.exitFullscreen());

export default subscribeToExitFullscreen;